export const fr = {
    "TRIGGER_LISTEN": "Écoute des déclencheurs",
    "ASSIST_EMPTY_MSG": "Agent AI écoute activement votre conversation et est prêt à aider automatiquement lorsqu'il est déclenché.",
    "MYBOT_TRIGGET_LISTEN": "Pas de tâches My Bot actives actuellement",
    "MYBOT_EMTPY_MSG": "Pour démarrer une tâche sur My Bot, allez dans l'onglet de recherche et sélectionnez l'option \"Exécuter avec les entrées de l'agent\" pour la tâche souhaitée.",
    "PROACTIVE_MODE": "Mode Proactif",
    "SETTINGS": "Paramètres",
    "AUTOSCROLL_ASSIST":"Assistance au défilement automatique",
    "AUTO_SCROLL_TOOLTIP":"Contrôle le défilement automatique de l'onglet Assistance, Mon bot et le contenu de l'onglet Transcription",
    "HELP_AND_SUPPORT": "Aide et support",
    "HELP": "Aide",
    "LANGUAGE": "Langue",
    "THEME": "Thème",
    "FILE_NAME":"Nom du fichier",
    "ASK_A_QUESTION":"Poser une question",
    "AUTOMATIC": "Automatique",
    "DARK": "Foncé",
    "LIGHT": "Clair",
    "THEME_DESC": "Ceci utilisera le mode par défaut de votre système",
    "DOCUMENTATION": "Documentation",
    "DOC_DESC": "Consultez nos articles de documentation approfondis.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Consultez les questions fréquemment posées sur Agent AI.",
    "KORE_ACADEMY": "Kore Academy",
    "KORE_ACA_DESC": "Apprenez-en plus sur Agent AI en suivant les cours de l'académie.",
    "SEARCH": "Rechercher",
    "MY_BOT": "Mon Bot",
    "ASSIST": "Assistance",
    "TRANSCRIPT": "Transcription",
    "TAP_SEARCH":"Appuyez pour rechercher",
    "HISTORY": "Historique",
    "STARTOVER": "Recommencer",
    "RESTART_INPUTS": "Recommencer avec les entrées capturées",
    "ASKCUSTOMER": "Demander au client",
    "TELLCUSTOMER": "Dire au client",
    "WELCOME_MSG": "Message de bienvenue",
    "SEND": "Envoyer",
    "SENT": "Envoyé",
    "AWAITING": "En attente de réponse | Tapez pour continuer",
    "OVERRIDE": "Tapez pour continuer",
    "ACCEPT_RESPONSE": "Réponse acceptée",
    "AGENT_ENTERED": "Agent entré",
    "EXPECTED_FORMAT": "Format attendu",
    "INPUT_VALUES": "Valeurs d'entrée",
    "RESTART": "Recommencer",
    "START_OVER": "Recommencer",
    "RESTART_CAPTURE": "Recommencer avec les entrées capturées",
    "CANCEL": "Annuler",
    "INTERRUPT_DIALOG": "TÂCHE DE DIALOGUE INTERROMPUE",
    "RUN": "Exécuter",
    "RUN_AGENT": "Exécuter avec l'entrée de l'agent",
    "STEP": "Pas",
    "DIALOG_TASK": "Tâche de dialogue",
    "FAQ": "FAQ",
    "SNIPPET": "Réponses",
    "ARTICLE": "Pages Web",
    "FILE": "Fichiers",
    "SUGGESTED": "Suggéré",
    "ALL_DIALOG": "Toutes les tâches de dialogue",
    "DIALOG_TEXT": "Dialogue",
    "INTENT_IDENTIFIED": "Énoncé du client",
    "NOT_WHAT_LOOKING": "Mauvaise suggestion ?",
    "BOT": "Bot",
    "CUSTOMER": "Client",
    "YOU": "Vous",
    "TERMINATE_CONV": "Terminer la tâche de dialogue",
    "TERMINATE_CONV_DESC": "Êtes-vous sûr de vouloir terminer la tâche de dialogue ? Agent AI ne pourra plus faire de suggestions.",
    "YES_TERMINATE": "Oui, terminer",
    "NO_CANCEL": "Non, annuler",
    "OVERRIDE_CONTINUE": "Continuer en mode de remplacement",
    "SUMMARY_TEXT": "Résumé",
    "SUBMIT": "Envoyer",
    "INTERRUPT_OCCURED": "Interruption survenue",
    "IDENTIFIED_INTENT": "Intention identifiée",
    "INTERRUPT_DESC": "L'exécution de ceci mettrait fin à votre tâche de dialogue en cours.",
    "ACCEPT_RUN": "Accepter et exécuter",
    "RUN_LATER": "Exécuter plus tard",
    "KNOW_MORE": "En savoir plus",
    "MORE_TEXT": "Plus",
    "LESS_TEXT": "Moins",
    "VIEW_MORE": "Afficher plus",
    "VIEW_LESS": "Afficher moins",
    "SHOW_MORE_FAQ": "Afficher plus de FAQs",
    "SHOW_LESS_FAQ": "Afficher moins de FAQs",
    "SHOW_MORE_ARTICLE": "Afficher plus de pages Web",
    "SHOW_LESS_ARTICLE": "Afficher moins de pages Web",
    "SHOW_MORE_SNIPPET": "Afficher plus de réponses",
    "SHOW_LESS_SNIPPET": "Afficher moins de réponses",
    "SHOW_MORE_FILES": "Afficher plus de fichiers",
    "SHOW_LESS_FILES": "Afficher moins de fichiers",
    "VIEW_ALL_DIALOG": "Afficher tous les dialogues",
    "VIEW_FEW_DIALOG": "Afficher quelques dialogues",
    "HELP_FULL": "Utile ?",
    "THANKYOU": "Merci !",
    "EXPAND_MORE": "Agrandir \/ Plus",
    "CLOSE_TEXT": "Fermer",
    "STARTED": "Démarré",
    "ENDED": "Terminé",
    "VIEW_FULL_ARTICLE": "Voir la page Web",
    "VIEW_FULL_FILE": "Voir le fichier",
    "COPIED": "Copié",
    "SENTI_ANALY": "Analyse de sentiment",
    "WRONG_SUGGESTION": "Mauvaise suggestion",
    "INCORRECT_INTENT": "Intention incorrecte",
    "ACCIDENTAL_CLICK": "Clic accidentel",
    "TIME_TAKING": "Trop de temps",
    "OTHER": "Autre",
    "PLAYBOOK_EMPTY_MSG": "Sélectionnez le Playbook",
    "PLAYBOOK_EMPTY_DESC": "Agent AI ne peut pas charger le playbook car tous les playbooks disponibles sont dynamiques. Cliquez sur 'Sélectionner le playbook' pour accéder au playbook",
    "STAGE": "Étape",
    "PROCEED_TO_CLOSE": "Passer à la fermeture",
    "RECOMENDED_PLAYBOOK": "PLAYBOOK RECOMMANDÉ",
    "PRIMARY_SCRIPTS": "SCRIPTS PRIMAIRES",
    "DYNAMIC_SCRIPTS": "SCRIPTS DYNAMIQUES",
    "RESUME": "Reprendre",
    "ENABLE_CLOSE": "Cliquez sur le bouton \"Passer à la fermeture\" pour activer la fermeture de l'étape",
    "LIST_VIEW": "Affichage liste",
    "TERMINATE": "Terminer",
    "MINIMIZE": "Réduire",
    "MAXIMIZE": "Agrandir",
    "NO_SEARCH_RESULT": "Aucun résultat de recherche trouvé",
    "SENTIMENT_AWAITING": "En attente du sentiment",
    "POSITIVE": "Positif",
    "NEGATIVE": "Négatif",
    "COPY" : "Copier",
    "PLAYBOOK": "Manuel de jeu",
    "TELL_US_MORE": "Dites-nous en plus",
    "TAB_TEXT":"Aucun onglet activé ! Veuillez activer au moins un onglet",
    "THANKS_FEEDBACK": "Merci pour vos commentaires",
    "SOMETHING_WRONG": "Quelque chose s'est mal passé",
    "CLICK_ERROR_DETAILS": "Cliquez pour voir les détails de l'erreur",
    "NO_ACTIVE_PLAYBOOK": "Aucun playbook actif",
    "REPHRASE_QUESTION": "Pouvez-vous reformuler votre question ou poser autre chose ?",
    "INTERNAL_INFO": "Informations internes",
    "SOURCES": "Sources",
    "CONVERSATION_SUMMARY": "Résumé de la conversation",
    "WAITING": "En attente",
    "WIDGET_DISABLED": "Widget désactivé",
    "AI_SETTINGS_DISABLED": "Les paramètres de l'IA sont désactivés ! Veuillez contacter l'administrateur de l'IA",
    "SERVER_CONNECTION_ERROR": "Erreur lors de la connexion au serveur",
    "VIEW": "Voir",
    "ATTACHMENT_INPUT": "Entrée de pièce jointe",
    "TYPE_SUMMARY": "Tapez le résumé",
    "VIEW_FULL_ARTICLE_2": "Voir l'article complet",
    "VIEW_FULL_FILE_2": "Voir le fichier complet",
    "BY":"Par",
    GENERATE_SUMMARY: "Générer un résumé",
    PREV_SUMMARIES: "Résumés générés précédemment",
    DIALOG_WORKFLOWS: "Flux de travail de dialogue",
    SHOW_ALL_DIALOG: "Afficher toutes les tâches de dialogue",
    SHOW_ALL_DIALOGS: "Afficher tous les dialogues",
    CUSTOM_TAB: "Onglet personnalisé",
    AGENT_INPUT: "Entrée de l'agent",
    "CUSTOM_EMPTY_MSG" : "Aucun flux de travail actif",
    "CUSTOM_TAB_DESC" : "Pour démarrer un flux de travail, exécutez l'un des flux de travail présents en bas de l'écran.",
    "SUBMIT_OVERALL_FEEDBACK" : "Envoyer un commentaire global",
    "FEEDBACK_POPUP_SUBTITLE" : "Commentaires sur le widget et ses fonctionnalités",
    "FEEDBACK_SATISFIED" : "Satisfait",
    "FEEDBACK_UNSATISFIED" : "Insatisfait",
    "FEEDBACK_PROVIDE_REASONS" : "Fournir plus d'informations…",
    "FEEDBACK_TITLE" : "Commentaire",
    "AGENTIC_THINKING" : "Réfléchit",
    "AGENTIC_AGENT_TITLE" : "Agent",
    "AGENTIC_COPILOT_MODE_TITLE" : "Mode Copilote Agentique",
    "AGENTIC_SENDING_MESSAGE" : "Envoi en cours...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot écoute activement votre conversation et est prêt à assister automatiquement",
    "AGENTIC_SEARCH_RESULTS" : "Résultats Agentiques",
    "PAUSE_AUTO_SEND" : "Pause Envoi Automatique",
    "PAUSE_AGENTIC" : "Pause Agentique",
    "RESUME_AGENTIC" : "Reprendre Agentique",
    "RESUME_AUTO_SEND" : "Reprendre Envoi Automatique"
}